// native
import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

// service
import { ApiService } from './api.service';

// models
import { PaginatedItems, TestStrategy, ExportTask, ExportTaskCreateBody } from '../../models';

// constants
import { API_EXPORT_TASK_PATH, DEFAULT_PAGE_INDEX, DEFAULT_PAGE_SIZE, EXPORT_TASK_TYPES, PROTOCOL, STRATEGY } from '../../constants';

@Injectable({
  providedIn: 'root'
})
export class ExportTaskService {
  constructor(
    private apiService: ApiService,
  ) { }

  create(exportTask: ExportTaskCreateBody): Observable<ExportTask> {
    return this.apiService.post(API_EXPORT_TASK_PATH, exportTask).pipe(map(res => res as ExportTask));
  }

  getAll(pageSize: number = DEFAULT_PAGE_SIZE, pageIndex: number = DEFAULT_PAGE_INDEX): Observable<PaginatedItems<ExportTask>> {
    let path = `${API_EXPORT_TASK_PATH}?limit=${pageSize}`;

    if (pageIndex)
      path = path + `&offset=${pageIndex * pageSize}`;
    return this.apiService.get(path, true) as Observable<PaginatedItems<ExportTask>>;
  }

  download(id: number): Observable<void> {
    return this.apiService.downloadFile(`${API_EXPORT_TASK_PATH}${id}/download/`);
  }

  getExportTaskTypes(): { name: string; value: string; }[] {
    return [
      {
        name: 'Perimetry',
        value: EXPORT_TASK_TYPES.PERIMETRY
      },
      {
        name: 'Acuity',
        value: EXPORT_TASK_TYPES.ACUITY
      },
      {
        name: 'Contrast Sensitivity Standard',
        value: EXPORT_TASK_TYPES.CONTRAST_SENSITIVITY_STANDARD
      },
      {
        name: 'Functional Vision',
        value: EXPORT_TASK_TYPES.FUNCTIONAL_VISION
      }
    ];
  }

  getStrategies(): TestStrategy[] {
    return [
      {
        name: 'Full Threshold (NormalT)',
        value: STRATEGY.FULL_THRESHOLD,
        protocols: [
          {
            name: '10-2 (Threshold)',
            value: PROTOCOL.FULL_THRESHOLD_10_2
          },
          {
            name: 'Pediatric 10-2 (Threshold)',
            value: PROTOCOL.FULL_THRESHOLD_PEDIATRIC_10_2
          },
          {
            name: '24-2 (Threshold)',
            value: PROTOCOL.FULL_THRESHOLD_24_2
          },
          {
            name: 'Pediatric 24-2 (Threshold)',
            value: PROTOCOL.FULL_THRESHOLD_PEDIATRIC_24_2
          },
          {
            name: '30-2 (Threshold)',
            value: PROTOCOL.FULL_THRESHOLD_30_2
          }
        ]
      },
      {
        name: 'AVA Standard',
        value: STRATEGY.AVA_STANDARD,
        protocols: [
          {
            name: '24-2 (AVAStandard)',
            value: PROTOCOL.AVA_STANDARD_24_2
          },
          {
            name: 'Pediatric 24-2 (AVAStandard)',
            value: PROTOCOL.AVA_STANDARD_PEDIATRIC_24_2
          },
          {
            name: '30-2 (AVAStandard)',
            value: PROTOCOL.AVA_STANDARD_30_2
          },
          {
            name: 'Pediatric 30-2 (AVAStandard)',
            value: PROTOCOL.AVA_STANDARD_PEDIATRIC_30_2
          }
        ]
      },
      {
        name: 'AVA Fast',
        value: STRATEGY.AVA_FAST,
        protocols: [
          {
            name: '24-2 (AVAFast)',
            value: PROTOCOL.AVA_FAST_24_2
          },
          {
            name: 'Pediatric 24-2 (AVAFast)',
            value: PROTOCOL.AVA_FAST_PEDIATRIC_24_2
          },
          {
            name: '30-2 (AVAFast)',
            value: PROTOCOL.AVA_FAST_30_2
          },
          {
            name: 'Pediatric 30-2 (AVAFast)',
            value: PROTOCOL.AVA_FAST_PEDIATRIC_30_2
          }
        ]
      }
    ];
  }
}
